exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay--active:before{opacity:1!important}[dir] .overlay--active:before{background:rgba(0,0,0,.5)!important}.dialog{overflow:hidden!important;overflow-y:auto!important}[dir] .dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important}.permission-group{position:relative}[dir] .permission-group{border:1px solid #ccc;border-radius:6px}.group-name{position:absolute;top:-10px;font-size:14px;text-transform:capitalize;color:rgba(0,0,0,.5)}[dir] .group-name{background:#fff}[dir=ltr] .group-name{left:5px}[dir=rtl] .group-name{right:5px}.input-group.input-group--selection-controls label{top:-3px!important}[dir=ltr] .input-group.input-group--selection-controls label{left:0!important}[dir=rtl] .input-group.input-group--selection-controls label{right:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ff91e61","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/roles/assignPermission.vue
// module id = 1233
// module chunks = 0